export const Types = {
  START_ADD_ORG_SETTINGS: 'START_ADD_ORG_SETTINGS',
  END_ADD_ORG_SETTINGS: 'END_ADD_ORG_SETTINGS',

  START_FETCH_ORG_SETTINGS: 'START_FETCH_ORG_SETTINGS',
  END_FETCH_ORG_SETTINGS: 'END_FETCH_ORG_SETTINGS',

  START_FETCH_ALL_ORG_SETTINGS: 'START_FETCH_ALL_ORG_SETTINGS',
  END_FETCH_ALL_ORG_SETTINGS: 'END_FETCH_ALL_ORG_SETTINGS',
}